const config = {
  questionsPerRound: parseInt(process.env.REACT_APP_QUESTIONS_PER_ROUND) || 10
};

export default config;